/** Date ranges for the AI usage audit. All dates are YYYY-MM-DD in UTC, `to` inclusive. */
export interface Period {
  key: string
  label: string
  from: string
  to: string
}

const ymd = (d: Date) => d.toISOString().slice(0, 10)

/** Calendar month `offset` months before the month of `now` (0 = current month) */
export function monthPeriod(now: Date, offset: number): Period {
  const first = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - offset, 1))
  const last = new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0))
  const label = first.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  })
  return {
    key: ymd(first).slice(0, 7),
    label: offset === 0 ? `This month (${label})` : label,
    from: ymd(first),
    to: ymd(last),
  }
}

/** The current month plus the previous `count - 1` months, newest first */
export function recentMonths(now: Date, count = 12): Period[] {
  return Array.from({ length: count }, (_, i) => monthPeriod(now, i))
}
